import React from "react";
import { DragOverlay, useDroppable } from "@dnd-kit/core";
import {
  rectSortingStrategy,
  SortableContext,
  verticalListSortingStrategy,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import { SortableItem } from "./SortableItem";
import { useTranslation } from "react-i18next";
export const ContainerSlide = React.memo(function ContainerSlide(props) {
  const {
    id,
    items,
    type,
    handleRemoveFromSlide,
    openEditSlide,
    feedType,
    countries,
  } = props;

  const { t } = useTranslation();

  const { setNodeRef } = useDroppable({
    id,
  });
  const typeId = "uuid";
  const dropItemsString = "Images";
  return (
    <SortableContext
      id={id}
      items={items?.map((item) => item[typeId])}
      strategy={horizontalListSortingStrategy}
    >
      <div ref={setNodeRef} className={"sortable-container"}>
        {items?.map((item, index) => {
          return (
            <div>
              <div className={"slide-actions"}>
                <DeleteOutlined
                  style={{ color: "red" }}
                  onClick={(e) => {
                    if (handleRemoveFromSlide) {
                      handleRemoveFromSlide(item);
                    }
                  }}
                />
                <EditOutlined
                  onClick={(e) => {
                    openEditSlide(e, item);
                    // openEdit(e, item);
                  }}
                />
              </div>
              <SortableItem
                item={item}
                key={`${index}${item[typeId]}`}
                id={item[typeId]}
                index={index}
                handleRemoveFromSlide={handleRemoveFromSlide}
                feedType={feedType}
                countries={countries}
              />
            </div>
          );
        })}
      </div>
    </SortableContext>
  );
});
